
import * as Website from './Config/Website.js';

import * as Common from './Page/Common/App.js';
import * as Home from './Page/Home/App.js';
import * as About from './Page/About/App.js';
import * as SpecialPurpose from './Page/SpecialPurpose/App.js';
import * as Overview from './Page/Overview/App.js';
import * as Faq from './Page/Faq/App.js';
import * as Requirements from './Page/Requirements/App.js';
import * as Purpose from './Page/Purpose/App.js';
import * as JobGuide from './Page/JobGuide/App.js';

import { getLenis } from './Lib/Lenis.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


let page = Website.status.page.toLowerCase();

Website.event.init();


// COMMON INIT
window.addEventListener("DOMContentLoaded", () => Common.preinit());
Common.init();
const lenis = getLenis();
window.addEventListener("load", () => Common.load());
window.addEventListener("resize", () => Common.resize());
window.addEventListener('widthchange', () => Common.resizeW());
window.addEventListener("scroll", () => Common.scroll());
window.addEventListener("orientationchange", () => Common.resize());
window.addEventListener("orientationchange", () => Common.scroll());


switch(page) {
  case "home": 
    Home.init();
    window.addEventListener('load', () => Home.load());
    window.addEventListener('resize', () => Home.resize());
    window.addEventListener('widthchange', () => Home.resizeW());
    window.addEventListener('scroll', () => Home.scroll());
    window.addEventListener("orientationchange", () => Home.resize());
    window.addEventListener("orientationchange", () => Home.scroll());
  break;
  case "about": 
    About.init();
    window.addEventListener('load', () => About.load());
    window.addEventListener('resize', () => About.resize());
    window.addEventListener('widthchange', () => About.resizeW());
    window.addEventListener('scroll', () => About.scroll());
    window.addEventListener("orientationchange", () => About.resize());
    window.addEventListener("orientationchange", () => About.scroll());
  break;
  case "special_purpose": 
    SpecialPurpose.init();
    window.addEventListener('load', () => SpecialPurpose.load());
    window.addEventListener('resize', () => SpecialPurpose.resize());
    window.addEventListener('widthchange', () => SpecialPurpose.resizeW());
    window.addEventListener('scroll', () => SpecialPurpose.scroll());
    window.addEventListener("orientationchange", () => SpecialPurpose.resize());
    window.addEventListener("orientationchange", () => SpecialPurpose.scroll());
  break;
  case "overview": 
    Overview.init();
    window.addEventListener('load', () => Overview.load());
    window.addEventListener('resize', () => Overview.resize());
    window.addEventListener('widthchange', () => Overview.resizeW());
    window.addEventListener('scroll', () => Overview.scroll());
    window.addEventListener("orientationchange", () => Overview.resize());
    window.addEventListener("orientationchange", () => Overview.scroll());
  break;
  case "faq": 
    Faq.init();
    window.addEventListener('load', () => Faq.load());
    window.addEventListener('resize', () => Faq.resize());
    window.addEventListener('widthchange', () => Faq.resizeW());
    window.addEventListener('scroll', () => Faq.scroll());
    window.addEventListener("orientationchange", () => Faq.resize());
    window.addEventListener("orientationchange", () => Faq.scroll());
  break;
  case "requirements": 
    Requirements.init();
    window.addEventListener('load', () => Requirements.load());
    window.addEventListener('resize', () => Requirements.resize());
    window.addEventListener('widthchange', () => Requirements.resizeW());
    window.addEventListener('scroll', () => Requirements.scroll());
    window.addEventListener("orientationchange", () => Requirements.resize());
    window.addEventListener("orientationchange", () => Requirements.scroll());
  break;
  case "purpose":
    Purpose.init();
    window.addEventListener('load', () => Purpose.load());
    window.addEventListener('resize', () => Purpose.resize());
    window.addEventListener('widthchange', () => Purpose.resizeW());
    window.addEventListener('scroll', () => Purpose.scroll());
    window.addEventListener("orientationchange", () => Purpose.resize());
    window.addEventListener("orientationchange", () => Purpose.scroll());
  break;
  case "jobguide":
    JobGuide.init();
    window.addEventListener('load', () => JobGuide.load());
    window.addEventListener('resize', () => JobGuide.resize());
    window.addEventListener('widthchange', () => JobGuide.resizeW());
    window.addEventListener('scroll', () => JobGuide.scroll());
    window.addEventListener("orientationchange", () => JobGuide.resize());
    window.addEventListener("orientationchange", () => JobGuide.scroll());
  break;
}
